import { render, staticRenderFns } from "./CoachingComponent.vue?vue&type=template&id=92fc51be&scoped=true&"
import script from "./CoachingComponent.vue?vue&type=script&lang=js&"
export * from "./CoachingComponent.vue?vue&type=script&lang=js&"
import style0 from "./CoachingComponent.vue?vue&type=style&index=0&id=92fc51be&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fc51be",
  null
  
)

export default component.exports